/**
 * useInquiries Hook
 * FSD: features/support/hooks
 *
 * 고객 문의 데이터 조회 및 상태 관리
 */

import { useQuery } from "@tanstack/react-query";
import { questionsAPI } from "@/entities/support/api/questions-api";

const INQUIRIES_QUERY_KEY = ["inquiries"];

export const useInquiries = () => {
  const { data, isLoading, error, isError, refetch } = useQuery({
    queryKey: INQUIRIES_QUERY_KEY,
    queryFn: () => questionsAPI.getSectionQuestions("inquiries"),
    staleTime: 1000 * 60 * 5, // 5분
    gcTime: 1000 * 60 * 10, // 10분
  });

  return {
    inquiriesList: data || [],
    isLoading,
    error: error?.message || (isError ? "문의사항 조회 실패" : null),
    refetch,
  };
};

export default useInquiries;
